import { render, staticRenderFns } from "./BulkProjectsListPage.vue?vue&type=template&id=511e157f&scoped=true&"
import script from "./BulkProjectsListPage.vue?vue&type=script&lang=ts&"
export * from "./BulkProjectsListPage.vue?vue&type=script&lang=ts&"
import style0 from "./BulkProjectsListPage.vue?vue&type=style&index=0&id=511e157f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511e157f",
  null
  
)

export default component.exports